import { MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

interface SelectLogicOperationProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  id: string;
  list: Readonly<Array<ItemVM>>;
  isSmallSize?: boolean;
}

const SelectLogicOperationComponent = ({
  disabled = false,
  onChange,
  value,
  id,
  list,
  isSmallSize = false,
}: SelectLogicOperationProps): React.ReactElement => {
  return (
    <PmiFormControl size={isSmallSize ? 'small' : undefined} fullWidth>
      <PmiSelect id={id} name={id} value={value} onChange={onChange} disabled={disabled}>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

SelectLogicOperationComponent.displayName = 'List logic operator component';

const SelectLogicOperation = memo(SelectLogicOperationComponent);

export default SelectLogicOperation as typeof SelectLogicOperationComponent;
